import { useState } from "react";
import {
  YearsDropdown,
  MonthsDropdown,
  CurrenciesDropdown,
} from "../../invoices/components/Invoices.Component";
import ApiButton from "../../../shared/ui/Api.Button";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { reportsConnector } from "../../../services/reports/connector";
import { compose } from "redux";

const MonthlyReportsComponent = ({ reports, getMonthReport }) => {
  let now = new Date();
  let year = now.getFullYear();

  let thisMonth = now.getMonth() + 1;
  let lastMonth = thisMonth - 1;

  if (lastMonth === 0) {
    lastMonth = 12;
    year = year - 1;
  }

  const [selectedYear, setSelectedYear] = useState(year);
  const [selectedMonth, setSelectedMonth] = useState(lastMonth);
  const [currency, setCurrency] = useState(1);

  const columns = [
    {
      key: "Ssn",
      label: "Ssn",
      filter: false,
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "Name", label: "Name", visible: true, type: CELL_TYPES.text },
    { key: "Tax", label: "Tax", visible: true, type: CELL_TYPES.money },
    { key: "Taxable", label: "Taxable", visible: true, type: CELL_TYPES.money },
  ];

  return (
    <div>
      <YearsDropdown
        year={selectedYear}
        setYear={(e) => setSelectedYear(e.target.value)}
      />
      <MonthsDropdown
        month={selectedMonth}
        setMonth={(e) => setSelectedMonth(e.target.value)}
      />
      <CurrenciesDropdown
        {...{ currency }}
        setCurrency={(e) => setCurrency(e.target.value)}
      />
      <ApiButton
        sending={reports.monthlyReports.fetching}
        sent={reports.monthlyReports.fetched}
        error={reports.monthlyReports.error}
        buttonLabel={"Get Report"}
        onButtonClick={getMonthReport.bind(
          this,
          selectedMonth,
          selectedYear,
          currency,
        )}
        style={{ verticalAlign: "top", marginTop: "10px" }}
      />
      {getData(selectedMonth, selectedYear)}
    </div>
  );

  function getData(month, year) {
    const data = reports.monthlyReports.data;

    if (reports.monthlyReports.fetched) {
      getCsv(data, month, year);
      return (
        <TableNew
          columns={columns}
          tableKey={"MonthlyReports"}
          items={data}
          actionColumnWidth={200}
        />
      );
    } else return <div> No data </div>;
  }

  function getCsv(data, month, year) {
    const blob = new Blob([convertToCSV(JSON.stringify(data))], {
      type: "octet/stream",
    });
    const fileName = "monthReport_" + month + "_" + year + ".csv";
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  function convertToCSV(objArray) {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";

        line += array[i][index];
      }

      str += line + "\r\n";
    }

    return str;
  }
};

export default compose(reportsConnector)(MonthlyReportsComponent);
